// MARK://dhk8/admin-shell/lib/queries/platform-orgs
// Queries tipadas de rollups de Organización (franquicia) — F3.6 / ADR-0009.
// El Admin (superadmin / multi-sucursal) lee los rollups por el grafo
// (platform-tenants), con gate authorizeOrgAccess (owner del JWT). Read-only.
import { graphql } from '../../gql/index.js'

export const OrgSalesRollupQuery = graphql(`
  query OrgSalesRollup($orgId: ID!, $from: String, $to: String) {
    orgSalesRollup(orgId: $orgId, from: $from, to: $to) {
      orgId orgSlug orgName
      period { from to }
      branches { tenantId brand displayName salesCents orderCount }
      totals { salesCents orderCount branchCount }
    }
  }
`)

export const OrgInventoryRollupQuery = graphql(`
  query OrgInventoryRollup($orgId: ID!) {
    orgInventoryRollup(orgId: $orgId) {
      orgId orgSlug orgName
      branches { tenantId brand displayName stockItemCount totalQty lowStockCount outOfStockCount }
      totals { stockItemCount totalQty lowStockCount outOfStockCount branchCount }
      topLowStock { tenantId brand stockItemId sku productId qty reorderPoint minQty uom }
    }
  }
`)

export const OrgCustomersRollupQuery = graphql(`
  query OrgCustomersRollup($orgId: ID!, $from: String, $to: String) {
    orgCustomersRollup(orgId: $orgId, from: $from, to: $to) {
      orgId orgSlug orgName
      period { from to }
      branches { tenantId brand displayName customerCount newCount activeBuyerCount recurringCount }
      totals { customerCount newCount activeBuyerCount recurringCount branchCount }
    }
  }
`)

export const OrgTopProductsRollupQuery = graphql(`
  query OrgTopProductsRollup($orgId: ID!, $from: String, $to: String, $limit: Int) {
    orgTopProductsRollup(orgId: $orgId, from: $from, to: $to, limit: $limit) {
      orgId orgSlug orgName limit
      period { from to }
      products { productId name totalQuantity lineCount orderCount byBranch { tenantId brand quantity orderCount } }
    }
  }
`)

export const OrgKpisRollupQuery = graphql(`
  query OrgKpisRollup($orgId: ID!, $from: String, $to: String) {
    orgKpisRollup(orgId: $orgId, from: $from, to: $to) {
      orgId orgSlug orgName
      period { from to }
      branches { tenantId brand displayName orderCount avgTicketCents peakHour peakHourOrders peakDow peakDowOrders }
      totals { orderCount avgTicketCents peakHour peakHourOrders peakDow peakDowOrders branchCount }
      heatmap { dow hour orderCount }
    }
  }
`)
